// extracted by mini-css-extract-plugin
export default {"canvas":"MfXCp5","hidden":"yXbKHw","visuallyHidden":"fBoz2H"};